

import React, { useRef, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faTags,
  faCalendar,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../config/config";
const AllBlogCard = () => {
  const carouselRef = useRef(null);
  const cardWidthRef = useRef(0);

  const scrollNext = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      const scrollAmount = carousel.offsetWidth;
      const atEnd =
        carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - 10;

      if (atEnd) {
        carousel.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  const scrollPrev = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      const scrollAmount = carousel.offsetWidth;
      carousel.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const isMobile = window.innerWidth < 768;
    let interval;

    if (isMobile) {
      const card = carousel.querySelector("div.flex-shrink-0");
      if (card) {
        const cardWidth = card.offsetWidth + 20; // 20 for gap-5 (margin)
        cardWidthRef.current = cardWidth;
      }

      interval = setInterval(() => {
        const scrollAmount = cardWidthRef.current;
        const atEnd =
          carousel.scrollLeft + carousel.offsetWidth >=
          carousel.scrollWidth - 10;

        if (atEnd) {
          carousel.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
      }, 3000);
    }

    return () => clearInterval(interval);
  }, []);

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/blogs/list`)
      .then((response) => {
        if (response.data.success) {
          setBlogs(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching blog list:", error);
      });
  }, []);

  const imageBaseURL = `${BASE_URL}/employees/view/`;

  return (
    <div className="bg-white">
      {/* Heading */}
      <div className="text-center py-10">
        <h2 className="text-2xl md:text-3xl font-semibold">
          <span className="text-black">OUR-LATEST </span>
          <span className="text-sky-500">BLOGS</span>
        </h2>
        <div className="relative w-fit mx-auto mt-2">
          <div className="h-[1px] bg-gray-300 w-[80px] md:w-[200px] mx-auto"></div>
          <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
            <div className="w-8 h-[2px] bg-sky-500"></div>
            <div className="w-8 h-[2px] bg-sky-500"></div>
          </div>
        </div>
      </div>

      {/* Carousel */}
      <div className="carousel-container px-5 relative container-wrapper">
        <div
          className="carousel flex gap-5 overflow-x-hidden snap-x snap-mandatory scroll-smooth no-scrollbar px-4"
          ref={carouselRef}
        >
          {blogs.map((item, i) => {
            const imageUrl = `${imageBaseURL}${item.image?.split("/").pop()}`;
            return (
              <div
                key={i}
                className="flex-shrink-0 w-[90vw] md:w-80 snap-center mb-11 rounded-md"
              >
                <div className="shadow-md rounded-lg overflow-hidden bg-white">
                  <img
                    src={imageUrl}
                    alt={item.alt || item.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="relative p-4">
                    <h3 className="font-semibold md:text-lg text-base mb-1 py-1">
                      {item.title}
                    </h3>
                    <div className="text-gray-600 text-xs flex flex-wrap gap-x-6 gap-y-2 items-center mb-2">
                      <span className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faUser} />
                        <span>{item.author}</span>
                      </span>

                      {Array.isArray(item.tags) && item.tags.length > 0 && (
                        <span className="flex items-center gap-1">
                          <FontAwesomeIcon icon={faTags} />
                          <span>{item.tags.join(", ")}</span>
                        </span>
                      )}

                      <span className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faCalendar} />
                        <span>{item.date}</span>
                      </span>
                    </div>
                    <p className="text-sm text-gray-700 mb-2 line-clamp-3">
                      {item.description}
                    </p>
                    <Link
                      to={`/blog/${item.title
                        .replace(/\s+/g, "-")
                        .toLowerCase()}`}
                      className="text-main font-semibold text-base hover:text-main1 flex items-center gap-1 hover:underline"
                    >
                      Continue reading
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className="text-xs ml-1"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Scroll Arrows (Desktop Only) */}
        <div className="hidden md:flex absolute top-1/2 transform -translate-y-1/2 w-full justify-between px-5 z-10">
          <FontAwesomeIcon
            icon={faChevronRight}
            onClick={scrollPrev}
            className="h-5 w-5 p-3 rounded-full bg-black/50 hover:bg-black text-white rotate-180 cursor-pointer"
          />
          <FontAwesomeIcon
            icon={faChevronRight}
            onClick={scrollNext}
            className="h-5 w-5 p-3 rounded-full bg-black/50 hover:bg-black text-white cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
};

export default AllBlogCard;
